import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

import { Store, select } from '@ngrx/store';

import { UserApiService } from 'src/app/api/services/user-api.service';

import { Dashboard } from '../core/models/core.models';

import { augmentObjectWithIconAndImage } from '../shared/utils/object-utils';

import { AppState } from '../core/state/app.state';
import * as fromReducers from '../core/state';

import { map, take, switchMap, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardResolver implements Resolve<Dashboard | null> {
  constructor(
    private store: Store<AppState>,
    private userApi: UserApiService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Dashboard | null> {
    const dashboardId = route.paramMap.get('dashboardId')!;

    return this.store.pipe(
      // grab the current user once
      select(fromReducers.selectUser),
      take(1),
      // switch into the direct HTTP call
      switchMap((user) =>
        this.userApi.getDashboard(user.id, dashboardId).pipe(
          // success → emit the Dashboard
          map((dashboard) => {
            return augmentObjectWithIconAndImage(dashboard);
          }),
          // failure → navigate or swallow, then emit null
          catchError((err) => {
            console.error('Dashboard load failed', err);
            //this.router.navigate(['/error']);   // optional
            return of(null);
          }),
        ),
      ),
    );
  }
}
